<template>
    <div>


        <WorkBox v-for="work in worksWithThisYear" :work="work" :key="work.id"></WorkBox>
    </div>
</template>

<script>
    import WorkBox from "../components/WorkBox";
    import _ from 'lodash'

    export default {
        name: "WorkYearPage",
        components: {WorkBox},
        computed: {
            worksWithThisYear: function () {
                console.log(this.$route.params)
                return _.filter(this.$store.state.works, {'year': parseInt(this.$route.params.year)})
            }
        }
    }
</script>

<style scoped lang="scss">
    a {
        color: maroon;

        &.router-link-exact-active {
            color: red;
        }

    }
</style>